import React from "react";
import styled from "styled-components";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useTranslation } from "react-i18next";

// Kleuren voor de grafieken
const COLORS = ["#F5E0B8", "#D7B1B1", "#C9E4CA", "#F7D2C4", "#F2C464", "#E8B422", "#C7B8EA", "#A3C6C6"];

const SalesTrendsChart = ({ trendData, topProductsByAmount }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardTitle>{t("sales_trends_top_5")}</CardTitle>
      <ChartContainer>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={trendData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            {topProductsByAmount.slice(0, 5).map((product, index) => (
              <Line
                key={product.id}
                type="monotone"
                dataKey={product.name}
                stroke={COLORS[index % COLORS.length]}
                activeDot={{ r: 8 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </ChartContainer>
    </Card>
  );
};

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const ChartContainer = styled.div`
  height: 24rem;
`;

export default SalesTrendsChart;
